/* global backUrl refreshCommitmentDataUrl revenueCommitmentStoreUrl uncommittedRevenuesCancelUrl */
/* global suppliersIndexUrl suppliersStoreUrl suppliersCreateUrl getRevenueMilestonesUrl */
/* global minDate maxDate listUsersUrl currentUserId revenue revenueProcurementId lineCrumbs */

import { React, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import RevenueCommitForm from './RevenueCommitForm';

import { idempotencyHeader } from 'Helpers/apiUtils';

import { UsersProvider } from 'Context/UsersContext';

export default function RevenueCommit() {
    // One idempotency key per mounted screen, so a double-clicked commit (or a retried
    // request) can never create two commitments for the same intent.
    const [mutationHeader] = useState(idempotencyHeader());

    return (
        <RevenueCommitForm
            backUrl={backUrl}
            refreshCommitmentDataUrl={refreshCommitmentDataUrl}
            storeUrl={revenueCommitmentStoreUrl}
            cancelUrl={uncommittedRevenuesCancelUrl}
            mutationHeader={mutationHeader}
            suppliersIndexUrl={suppliersIndexUrl}
            suppliersStoreUrl={suppliersStoreUrl}
            suppliersCreateUrl={suppliersCreateUrl}
            getRevenueMilestonesUrl={getRevenueMilestonesUrl}
            minDate={minDate}
            maxDate={maxDate}
            listUsersUrl={listUsersUrl}
            currentUserId={currentUserId}
            revenue={revenue}
            revenueProcurementId={revenueProcurementId}
            lineCrumbs={lineCrumbs}
        />
    );
}

if (document.getElementById('RevenueCommit')) {
    var root = document.getElementById('RevenueCommit');
    ReactDOM.render(
        <App>
            <UsersProvider fetchUrl={listUsersUrl}>
                <RevenueCommit />
            </UsersProvider>
        </App>,
        root,
    );
}
